import {
  ADD_CAMPAIGN_SOURCE,
  DELETE_CAMPAIGN_SOURCE, GET_CAMPAIGN_SOURCE_PROFILE,
  GET_CAMPAIGN_SOURCES_LIST,
  HIDE_CAMPAIGN_SOURCES_LIST_LOADER, SET_CAMPAIGN_SOURCE_PROFILE,
  SET_CAMPAIGN_SOURCES_LIST, SET_ERROR_CAMPAIGN_SOURCE_PROFILE,
  SHOW_CAMPAIGN_SOURCES_LIST_LOADER, UPDATE_CAMPAIGN_SOURCE_PROFILE
} from "./actionTypes";

export const getCampaignSourcesList = data => ({
  type: GET_CAMPAIGN_SOURCES_LIST,
  payload: data
});

export const setCampaignSourcesList = payload => ({
  type: SET_CAMPAIGN_SOURCES_LIST,
  payload
});

export const showCampaignSourcesListLoader = () => ({
  type: SHOW_CAMPAIGN_SOURCES_LIST_LOADER
});

export const hideCampaignSourcesListLoader = () => ({
  type: HIDE_CAMPAIGN_SOURCES_LIST_LOADER
});

export const addCampaignSource = (source = {}, data = {}) => ({
  type: ADD_CAMPAIGN_SOURCE,
  payload: { source, data }
});

export const deleteCampaignSource = (id, data = {}) => ({
  type: DELETE_CAMPAIGN_SOURCE,
  payload: { id, data }
});

export const getCampaignSourceProfile = id => ({
  type: GET_CAMPAIGN_SOURCE_PROFILE,
  payload: id
});

export const setCampaignSourceProfile = payload => ({
  type: SET_CAMPAIGN_SOURCE_PROFILE,
  payload
});

export const updateCampaignSourceProfile = (id, source = {}, data = {}) => ({
  type: UPDATE_CAMPAIGN_SOURCE_PROFILE,
  payload: {id, source, data }
});

export const setErrorCampaignSourceProfile = payload => ({
  type: SET_ERROR_CAMPAIGN_SOURCE_PROFILE,
  payload
});
